import * as Long from "long";
import { ofType } from "redux-observable";
import { from, of, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectActiveInvite, selectCoopLevelFromXp } from "../../../selectors/selectCoopInfo";
import { selectEventInfosByEventType } from "../../../selectors/selectEventInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, PlayerPreferencesPlatformType, } from "../../../utils/network/generated/protoTypes";
import { utilNumber } from "../../../utils/utilNumber";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionEventInfoRequest } from "../../info/event/actionEventInfo";
import { actionServerPersistenceSetInfo } from "../../server-persistence/actionServerPersistence";
import { actionCoopClearSelectedCoop, actionCoopInfoInviteInfoUpdate, actionCoopInfoPlayerCancelInvite, actionCoopInfoReceived, actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, TypeActionCoopInfo, } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
export var epicCoopJoinCoop = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.JoinCoop), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var activeInvite = selectActiveInvite(state);
        return deps
            .netSend({
            id: CommandCode.JoinCoop,
            props: {
                coopId: action.coopId,
                playerId: playerId,
            },
        })
            .pipe(switchMap(function (response) {
            // 1 is the minimum coop level
            var level = response.coop !== undefined && response.coop.xp !== undefined
                ? selectCoopLevelFromXp(Long.fromValue(response.coop.xp))
                : 1;
            var actions = [
                actionCoopMenuSetFirstTab(IdCoopCategory.CoopInfoView),
                actionCoopMenuTabGoTo(IdCoopCategory.CoopInfoView),
                actionCoopClearSelectedCoop(),
                actionCoopInfoReceived(response),
                actionServerPersistenceSetInfo({
                    key: IdPersistence.CoopPreviousLevel,
                    platform: PlayerPreferencesPlatformType.PLAT_SHARED,
                    value: utilNumber.format(level),
                }),
            ];
            if (activeInvite &&
                response.coop &&
                activeInvite.coopId === response.coop.id) {
                actions.push(actionCoopInfoInviteInfoUpdate());
            }
            var eventInfo = selectEventInfosByEventType(state, EventType.CoopLeague);
            if (eventInfo !== undefined && eventInfo.proto.eventId !== undefined) {
                actions.push(actionEventInfoRequest());
            }
            return from(actions);
        }), catchError(function (error) {
            if (activeInvite !== undefined && activeInvite.coopId === action.coopId) {
                return of(actionCoopInfoPlayerCancelInvite());
            }
            return throwError(error);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopJoinCoop.ts
// module id = 1810
// module chunks = 3